import { inject, Injectable, Injector } from "@angular/core";
import { ReplaySubject, lastValueFrom } from "rxjs";
import { isEmpty } from "../utils/Utility";
import { HttpRequestService } from "./http-request.service";
import { UtenteService } from "./utente.service";

@Injectable({
    providedIn: 'root'
})
export class FunzionalitaService {
    private http = inject(HttpRequestService);
    private injector = inject(Injector);


    funzionalita: string[] = []

    funzionalitaLoaded$ = new ReplaySubject<boolean>(1)

    private utenteService: UtenteService

    mustLoad() {
        return !this.funzionalita || this.funzionalita.length === 0
    }

    async loadFunzionalita() {
        const response = await lastValueFrom(this.getFunzionalita())

        this.funzionalita = response.data.funzionalita

        this.funzionalitaLoaded$.next(true)
    }

    getFunzionalita() {
        return this.http.get('/siev_fget_funzionalita', {}, {}, false, false)
    }

    pulisciFunzionalita() {
        this.funzionalita = null;
    }

    isFunzionalitaAbilitata(fun: string) {
        return !isEmpty(this.funzionalita.find(f => f.toLowerCase().indexOf(fun.toLowerCase()) > -1))
    }




    /**
     * Restituisce true se le comunicazioni sono abilitate
     *
     * NOTA: le comunicazioni sono abilitate SEMPER se l'utente ha un medico
     * @returns
     */
    isComunicazioniAbil() {
        if (!this.utenteService) {
            this.utenteService = this.injector.get(UtenteService)
        }

        return !this.utenteService.isWithoutDoctor()
    }

    /**
     * Restituisce, se presente, il testo della risposta automatica del giorno di oggi
     * @returns
     */
    getTestoRispostaAutomatica() {
        if (!this.utenteService) {
            this.utenteService = this.injector.get(UtenteService)
        }

        const rispostaAutomatica = this.utenteService.getChiave(['paziente', 'rispostaAutomaticaOggi'])
        return rispostaAutomatica?.testo
    }

    /**
     * Restituisce true se le comunicazioni sono bloccate,
     * ovvero se un medico ha impostato una risposta automatica con il blocci delle comunicazioni
     * @returns
     */
    isComunicazioniBloccate() {
        if (!this.utenteService) {
            this.utenteService = this.injector.get(UtenteService)
        }

        const rispostaAutomatica = this.utenteService.getChiave(['paziente', 'rispostaAutomaticaOggi'])
        return rispostaAutomatica?.blocca_comunicazioni === true
    }

    /**
     * Restituisce true se le risposte sono abilitate
     */
    isComunicazioniNuoveAbil() {
        if (!this.utenteService) {
            this.utenteService = this.injector.get(UtenteService)
        }

        return (this.isFunzionalitaAbilitata('Comunicazioni') || this.isFunzionalitaAbilitata('Referti')) && !this.utenteService.isWithoutDoctor()
    }

    /**
     * Restituisce true se le risposte sono abilitate
     * @returns
     */
    isComunicazioniNuovoRisposteAbil() {
        if (!this.utenteService) {
            this.utenteService = this.injector.get(UtenteService)
        }

        return this.isFunzionalitaAbilitata('Comunicazioni') && !this.utenteService.isWithoutDoctor()
    }

    /**
     * Il diario dei farmaci è sempre attivo
     * @returns
     */
    isFarmaciAbil() {
        return true; //this.isFunzionalitaAbilitata('Sincronizzazione Farmaci') || this.isFunzionalitaAbilitata('Tutti i farmaci')
    }

    isParametriAbil() {
        return this.isFunzionalitaAbilitata('Parametri')
    }

    isEsenzioniAbil() {
        return this.isFunzionalitaAbilitata('Sincronizzazione Esenzioni')
    }

    isAllergieAbil() {
        return this.isFunzionalitaAbilitata('Sincronizzazione Allergie')
    }

    isScadenzeAbil() {
        return this.isFunzionalitaAbilitata('Sincronizzazione Scadenze')
    }

    isEsamiAbil() {
        return this.isFunzionalitaAbilitata('Sincronizzazione esami di laboratorio')
    }

    isPresidiAbil() {
        return this.isFunzionalitaAbilitata('Sincronizzazione Presidi')
    }

    isProcDiaAbil() {
        return this.isFunzionalitaAbilitata('Sincronizzazione Procedure Diagnostiche')
    }

    isProcTerAbil() {
        return this.isFunzionalitaAbilitata('Sincronizzazione Procedure Terapeutiche')
    }

    isAppuntamentiAbil() {
        return this.isFunzionalitaAbilitata('Appuntamenti')
    }

    isCertInpsAbil() {
        return !this.isFunzionalitaAbilitata('noInps')
    }

    isPiaTerAbil() {
        return !this.isFunzionalitaAbilitata('noPter')
    }

    isTAOAbil() {
        return !this.isFunzionalitaAbilitata('noTao')
    }

    isSpeseAbil() {
        if (!this.utenteService) {
            this.utenteService = this.injector.get(UtenteService)
        }

        // se ho già inserito almeno un record devo mostrarla a prescindere
        if (this.isFunzionalitaAbilitata('siSpese')) {
            return true
        }

        // abilitato solo per gli utenti sct
        return !this.utenteService.isNextComunicaAttivo()
    }

    isCartPersAbil() {
        if (!this.utenteService) {
            this.utenteService = this.injector.get(UtenteService)
        }

        // se ho già inserito almeno un record devo mostrarla a prescindere
        if (this.isFunzionalitaAbilitata('siCartPers')) {
            return true
        }

        // abilitato solo per gli utenti sct
        return !this.utenteService.isNextComunicaAttivo()
    }
}
